import { TOGGLE_BASEMAP_SELECTOR } from 'constants/actionTypes';

const initialState = false;

export default (state = initialState, action) => {
  switch (action.type) {
    case TOGGLE_BASEMAP_SELECTOR:
      return action.boolean;
    default:
      return state;
  }
};
